import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { CHART_ACCENT, CHART_GRID, axisTickStyle, tooltipContentStyle, tooltipLabelStyle } from './chartTheme';

const SESSIONS_COLOR = '#22c55e';
const ERRORS_COLOR = '#ef4444';

const formatShortDate = (dateStr) => {
  const d = new Date(`${dateStr}T00:00:00Z`);
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', timeZone: 'UTC' });
};

// Page views / sessions / errors per day
const EventsByDayChart = ({ data }) => (
  <ResponsiveContainer width="100%" height={240}>
    <LineChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
      <CartesianGrid stroke={CHART_GRID} strokeDasharray="0" vertical={false} />
      <XAxis
        dataKey="date"
        tickFormatter={formatShortDate}
        tick={axisTickStyle}
        axisLine={{ stroke: CHART_GRID }}
        tickLine={false}
        interval={Math.max(0, Math.floor((data?.length || 0) / 6) - 1)}
      />
      <YAxis allowDecimals={false} tick={axisTickStyle} axisLine={false} tickLine={false} width={36} />
      <Tooltip
        contentStyle={tooltipContentStyle}
        labelStyle={tooltipLabelStyle}
        labelFormatter={formatShortDate}
        cursor={{ stroke: CHART_GRID }}
      />
      <Legend wrapperStyle={{ fontSize: 12, color: '#686868' }} />
      <Line type="monotone" dataKey="pageViews" name="Page views" stroke={CHART_ACCENT} strokeWidth={2} dot={false} />
      <Line type="monotone" dataKey="sessions" name="Sessions" stroke={SESSIONS_COLOR} strokeWidth={2} dot={false} />
      <Line type="monotone" dataKey="errors" name="Errors" stroke={ERRORS_COLOR} strokeWidth={2} dot={false} />
    </LineChart>
  </ResponsiveContainer>
);

export default EventsByDayChart;
